// Libs
import React, { useState, useEffect } from 'react';
import { ReactElement } from 'react';
import { Paper, Typography, Slide, Snackbar } from 'ui-components';
import { VARIANTS_ICONS } from './callback-snackbar.constants';
import clsx from 'clsx';
// App
import { CallbackSnackbarProps } from './callback-snackbar.interfaces';

import styles from './callback-snackbar.module.scss';

const CallbackSnackbar = (props: CallbackSnackbarProps): ReactElement => {
  const { message, variant = 'success', showIcon = true, onClose } = props;
  const [isSnackBarOpen, setSnackBarOpen] = useState(false);

  /**
   * Set target properties to trigger transition
   */
  useEffect(() => {
    setSnackBarOpen(true);
  }, []);

  /**
   * Closes snackbar
   */
  const handleSnackBarClose = () => {
    setSnackBarOpen(false);
    onClose();
  };

  return (
    <Snackbar
      className={styles.snackbar}
      open={isSnackBarOpen}
      onClose={handleSnackBarClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={2000}
      TransitionComponent={(props) => <Slide {...props} direction="down" />}
    >
      <Paper className={styles.paper} elevation={1}>
        <Typography variant="body2" className={clsx(styles.typography, styles[variant])}>
          {showIcon && <span className={styles.icon}>{VARIANTS_ICONS[variant]}</span>}
          {message}
        </Typography>
      </Paper>
    </Snackbar>
  );
};

export default CallbackSnackbar;
